var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "VBtn",
    {
      staticClass: "close-btn",
      attrs: {
        outlined: "",
        fab: "",
        "x-small": "",
        color: _vm.colors.jambalaya,
        elevation: "0",
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [_c("VIcon", [_vm._v("mdi-close")])],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }